import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { isIndex } from '@icp/utils';
import { toDecimalPrecision } from '@icp/form-renderer-core';
import NumberPickerElement from '../../NumberPickerElement';
import { CurrentDataProvider } from '../../../currentDataCtx';

function NumberCellEditor(props) {
  const {
    api: gridApi,
    node,
    colDef,
    value,
    onValueChange,
    cellStartedEdit,
    eventKey,
    data,
    context,
    componentProps,
  } = props;

  const { precision, stringMode } = componentProps || {};

  const refInput = useRef(null);
  const valueRef = useRef(null);
  valueRef.current = value;

  useEffect(() => {
    let highlightAllOnFocus = true;

    if (isIndex(eventKey)) {
      highlightAllOnFocus = false;
      onValueChange(Number(eventKey));
    }

    if (highlightAllOnFocus) {
      refInput.current.node.querySelector('input').select();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // antd 自带 precision 逻辑，但是它的实现方式是在 blur 过后多触发一次 onChange 处理了 precision 的结果，
  // 表格触发 blur 会优先于 antd 的 blur 触发，直接退出编辑把 antd 卸载，导致拿不到处理 precision 过后的值，所以这里主动处理一下。
  useEffect(() => {
    return () => {
      const newValue = toDecimalPrecision(valueRef.current, precision, stringMode);
      if (newValue !== valueRef.current) {
        // 不能用 onValueChange，应该是因为 onValueChange ag-grid 传进来会发生变化的调用无用，
        // 只能用 node.setDataValue 去直接修改
        node.setDataValue(colDef.colId, newValue);
      }
    };
  }, [colDef.colId, gridApi, node, precision, stringMode]);

  return (
    <CurrentDataProvider value={data}>
      <NumberPickerElement
        className="table-number-editor"
        suppressFormControl={true}
        value={value}
        onChange={onValueChange}
        componentProps={{
          size: context.tableSize,
          autoFocus: cellStartedEdit,
          ...componentProps,
          changeDelayToBlur: false,
        }}
        ref={refInput}
      />
    </CurrentDataProvider>
  );
}

NumberCellEditor.propTypes = {
  api: PropTypes.shape({}),
  node: PropTypes.shape({
    setDataValue: PropTypes.func,
  }),
  colDef: PropTypes.shape({
    colId: PropTypes.string,
  }),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onValueChange: PropTypes.func,
  cellStartedEdit: PropTypes.bool,
  eventKey: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  context: PropTypes.shape({
    tableSize: PropTypes.oneOf(['default', 'small']),
    yupSchema: PropTypes.shape({
      validateSyncAt: PropTypes.func,
    }),
  }),
  validation: PropTypes.shape({
    required: PropTypes.bool,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
  }),
  componentProps: PropTypes.shape({
    precision: PropTypes.number,
    stringMode: PropTypes.bool,
  }),
};

export default NumberCellEditor;
